__turbopack_context__.v({
  "aboutLabel": "_1mviLW_aboutLabel",
  "aiBadge": "_1mviLW_aiBadge",
  "checkboxLabel": "_1mviLW_checkboxLabel",
  "checkboxText": "_1mviLW_checkboxText",
  "form": "_1mviLW_form",
  "imageRow": "_1mviLW_imageRow",
  "panel": "_1mviLW_panel",
});
